<template>
  <v-hover
    v-slot:default="{ hover }"
    :open-delay="$store.state.experiments['HOVER_CHIP_OPEN_DELAY']"
    :close-delay="$store.state.experiments['HOVER_CHIP_CLOSE_DELAY']"
  >
    <v-chip class="mr-2" :color="color" @click="click" :to="to" :href="href">
      <v-icon>{{ icon }}</v-icon>
      <v-expand-x-transition>
        <span v-if="hover || !$store.state.experiments['HOVER_CHIP_HOVER']"
          >&nbsp;{{ text }}</span
        >
      </v-expand-x-transition>
    </v-chip>
  </v-hover>
</template>

<script>
export default {
  name: "HoverChip",
  props: ["text", "action", "icon", "color", "to", "href"],
  methods: {
    click() {
      this.$emit("click")
    }
  }
}
</script>

<style scoped></style>
